// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"994bdce8","732":"5e688ee5","844":"53c0897c","977":"a459f027"}[chunkId] + ".chunk.js";
};